import { Box, styled } from "@mui/material";

export const SearchBar = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "1.25rem",
  alignSelf: "stretch",
  borderRadius: "0.5rem",
  background: theme.palette.common.neutral[95],
  paddingLeft: "1rem",
  maxWidth: "22.5rem",
}));
